import Swiper, { Navigation, Scrollbar, Zoom, Mousewheel, Pagination } from 'swiper';

const heroProductGallery = (isInline) => ({
  currentSlide: 0,
  swiper: null,
  swiperThumbnails: null,
  swiperEl: null,
  swiperThumbnailsEl: null,
  cachedVideoElements: null,

  init() {
    this.$nextTick(() => {
      this.initializeThumbnails();
      this.initializeGallery();
      this.initVideoAutoPause();
    });
  },

  initializeThumbnails() {
    const el = this.$root.querySelector('.js-gallery-thumbnails-swiper');
    if (!el) return;

    const specificConfig = {
      direction: 'vertical',
      spaceBetween: 12,
      breakpoints: {
        0: {
          enabled: false,
        },
        1280: {
          enabled: true,
        },
      },
    };

    this.swiperThumbnailsEl = el;
    this.swiperThumbnails = new Swiper(el, {
      slidesPerView: 'auto',
      modules: [Mousewheel],
      mousewheel: {
        forceToAxis: true,
      },
      ...specificConfig,
    });
  },

  initializeGallery() {
    const el = this.$root.querySelector('.js-gallery-swiper');
    if (!el) return;

    this.swiperEl = el;
    this.swiper = new Swiper(el, {
      modules: [Navigation, Scrollbar, !isInline && Zoom, Pagination].filter(Boolean),
      zoom: !isInline,
      breakpoints: {
        0: {
          direction: 'horizontal',
          spaceBetween: 12,
          pagination: {
            el: this.swiperEl.querySelector('.swiper-pagination'),
            type: 'fraction',
          },
        },
        1280: {
          direction: 'vertical',
          allowTouchMove: false,
          simulateTouch: false,
        },
      },
      slidesPerView: 'auto',
      preloadImages: false,
      on: {
        afterInit: (swiper) => {
          if (this.currentSlide !== 0) {
            swiper.slideTo(this.currentSlide, 0);
          }
        },
        slideChange: (swiper) => {
          this.currentSlide = swiper.activeIndex;
          this.swiperThumbnails.slideTo(swiper.activeIndex);
          this.handleVideoPlayback(swiper); // Handle video playback on slide change

          if (!isInline) {
            // defined in modal components
            this.currentSlideInfo = `${swiper.activeIndex + 1}/${swiper.slides.length}`;
          }
        },
      },
      scrollbar: isInline && {
        el: this.swiperEl.querySelector('.swiper-scrollbar'),
      },
      navigation: {
        nextEl: this.swiperEl.querySelector('.swiper-btn-next'),
        prevEl: this.swiperEl.querySelector('.swiper-btn-prev'),
        disabledClass: 'pointer-events-none opacity-30',
      },
    });
  },

  initVideoAutoPause() {
    const gallerySection = this.$root.querySelector('.main-hero-carousel');

    if (!gallerySection || !this.swiperEl) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            this.pauseAllVideos(); // Pause videos when the gallery is out of view
          }
        });
      },
      { threshold: 0.1 },
    );

    observer.observe(gallerySection);
  },

  pauseAllVideos() {
    const videoElements = this.cachedVideoElements || this.swiperEl.querySelectorAll('.swiper-slide.has-video video');
    videoElements.forEach((video) => {
      video.pause();
    });
  },

  handleVideoPlayback(swiper) {
    const videoElements = this.cachedVideoElements || swiper.el.querySelectorAll('.swiper-slide.has-video video');

    // Cache the video elements for future use
    if (!this.cachedVideoElements) {
      this.cachedVideoElements = videoElements;
    }

    // Pause video in all Video slides
    videoElements.forEach((videoElement) => {
      videoElement.pause();
    });

    const currentSlideEl = swiper.slides[swiper.activeIndex];

    if (!currentSlideEl || !currentSlideEl.classList.contains('has-video')) return;
    const currentVideoEl = currentSlideEl.querySelector('video');
    if (!currentVideoEl) return;
    currentVideoEl.play(); // Autoplay the video on the current slide
  },

  navigateToVariantSlide({ media_id }) {
    if (!this.swiper || !media_id) return;

    const targetIndex = this.swiper.slides.findIndex((slide) => slide.dataset.mediaId === media_id.toString());

    if (targetIndex !== -1 && targetIndex !== this.swiper.activeIndex) {
      this.swiper.slideTo(targetIndex);
    }
  },

  openModal() {
    this.$dispatch('hero-product-gallery-open-modal-image', this.currentSlide);
    this.$root.parentElement.querySelector('dialog').showModal();
  },

  handleOpenModalImage({ detail: idx }) {
    if (!isInline) {
      this.swiper.slideTo(idx, 0);
    }
  },
});

export default heroProductGallery;
